var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ww-app"},[_c('WebMenu'),_c('div',{staticClass:"ww-container ww-app__content"},[_vm._t("default"),_c('WebFooter')],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }